import { render, staticRenderFns } from "./ThirdQuote.vue?vue&type=template&id=b31bcdcc&scoped=true"
import script from "./ThirdQuote.vue?vue&type=script&lang=js"
export * from "./ThirdQuote.vue?vue&type=script&lang=js"
import style0 from "./ThirdQuote.vue?vue&type=style&index=0&id=b31bcdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31bcdcc",
  null
  
)

export default component.exports